module.exports = __webpack_public_path__ + "img/user_tie.93671fbd.svg";